module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-course"
  }, [_c('div', {
    staticClass: "box-course-home"
  }, [_c('div', {
    staticClass: "box-course-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("landing.course.title")))]), _c('a', {
    staticClass: "view-more",
    on: {
      "click": _vm.commingSoon
    }
  }, [_vm._v(_vm._s(_vm.$t("home.view_more")) + " >>")])]), _c('div', {
    staticClass: "box-course-search"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key_course),
      expression: "key_course"
    }],
    attrs: {
      "placeholder": _vm.$t('landing.course.keyword')
    },
    domProps: {
      "value": (_vm.key_course)
    },
    on: {
      "keyup": _vm.onCourseChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key_course = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "addons-button-clear",
    style: (_vm.clear_course ? 'display:block;' : 'display:none;'),
    on: {
      "click": _vm.onCourseClear
    }
  }), _c('div', {
    staticClass: "addons-button",
    on: {
      "click": _vm.onCourseSearch
    }
  }, [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])])]), _c('div', {
    staticClass: "box-course-content"
  }), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "beehive"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/faces/ic_mark_khoahocc@2x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-529f3bbb","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/Course/index.vue
// module id = 1561
// module chunks = 0